import { createFileRoute } from "@tanstack/react-router";

/** `/support#r=..&t=..` from the admin app. The gate starts the session. */
export const Route = createFileRoute("/support")({ component: () => null });
